"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var ShowMoreButton = function ShowMoreButton(_ref) {
  var href = _ref.href,
      label = _ref.label;
  var external = typeof window !== 'undefined' && !href.includes(window.location.hostname);

  if (external) {
    return (0, _preact.h)("a", {
      className: "featured-topics__show-more-button",
      href: (0, _absoluteUrlRuntime.resolveUrl)(href),
      target: "_blank",
      rel: "noreferrer nofollow noopener"
    }, (0, _preact.h)(_Button.default, {
      title: label,
      variant: "cta",
      size: "medium"
    }));
  }

  return (0, _preact.h)("a", {
    className: "featured-topics__show-more-button",
    href: (0, _absoluteUrlRuntime.resolveUrl)(href)
  }, (0, _preact.h)(_Button.default, {
    title: label,
    variant: "cta",
    size: "medium"
  }));
};

var _default = ShowMoreButton;
exports.default = _default;